module.exports = __webpack_public_path__ + "static/media/WebDarkMode.84fbbc46.png";